import { useUserStore } from '@/store/user'
import ExamImagePreAnalysis from './ExamImagePreAnalysis.vue'
// import ExamConnectorSendOffcanvas from './ExamConnectorSendOffcanvas.vue'

import lgAutoplay from 'lightgallery/plugins/autoplay';
import lgFullscreen from 'lightgallery/plugins/fullscreen';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgVideo from 'lightgallery/plugins/video';
import lgZoom from '@/assets/dependencies/lightGallery/plugins/zoom';
// import lgZoom from 'lightgallery/plugins/zoom';

const TAG = '[ExamImageTab]'
const IS_PRODUCTION = process.env.NODE_ENV == 'production'

export default {
  name: 'ExamImageTab',
  props: ['exam_id', 'altscore', 'alert_msg', 'patient'],
  components: {
    ExamImagePreAnalysis,
    // ExamConnectorSendOffcanvas,
  },
  data: () => ({
    loading: false,
    alert: {
      title: null,
      message: null,
      class: null
    },
    exam: null,
    examImages: [],
    filterSelected: [],
    filterOptions: [],
    thumbDataPath: null,
    thumbVideoPath: null,
    dataPath: null,
    modalType: null,
    session: null,
    selectedImages: [],
    imageToCrop: null,
    showAccessInfoModal: false,
    isSpecialist: false,
    lightGallerySettings: {
      showZoomInOutIcons: true,
      actualSize: false,
      autoplayVideoOnSlide: true,
      speed: 300,
      licenseKey: 'CE440F6C-34CE4C2A-86065648-48895C83',
      plugins: [],
      preload: 1,
      videojs: false
    },
    isValidForHeatmap: false,
    lightGallery: null,
    hasIaAdvancedFunctions: false,
    showMutirao: false,
    isPowerfull: null,
    hoverVideoTimer: null,
    playingVideoIndex: null,
  }),
  watch: {
    alert_msg (newVal) {
      if (newVal) {
        this.alert.message = newVal.message
        this.alert.class = newVal.class
        this.fetchData()
      } else {
        this.alert.message = null
      }
    },
  },
  computed: {
    alertClass() {
      return this.alert.class
    },
    filteredExamImages() {
      return this.examImages.filter(img => !img.type.startsWith('OTHER_') && img.type !== 'RNFL_RAW');
    }
  },
  created() {
    const userStore = useUserStore()
    this.session = userStore.sessionInfo

    this.hasIaAdvancedFunctions = this.session.features.includes('iaAdvancedFunctions')
    this.showMutirao = this.session.features.includes('mutirao')
    this.isSpecialist = this.session.isSpecialist

    this.lightGallerySettings.plugins = [lgAutoplay, lgFullscreen, lgThumbnail, lgVideo, lgZoom]
  },
  async mounted() {
    await this.fetchData()
    this.webSocketInitialization()
    this.isPowerfull = this.session.isPowerfull;
  },
  beforeUnmount() {
    clearTimeout(this.hoverVideoTimer)
  },
  methods: {
    onVideoHoverStart(index) {
      this.$utils.startHoverPreview(this, index)
    },
    onVideoHoverEnd(index) {
      this.$utils.cancelHoverPreview(this, index)
    },
    playHoverVideo(el) {
      this.$utils.playHoverVideo(el)
    },
    doFilter(imageType) {
      let images = document.querySelectorAll('.image-info-box > .thumbnail-box');
      let hasImg = _.find(this.filterSelected, function (o) { return o == imageType; });

      if (hasImg) {
        this.filterSelected = _.remove(this.filterSelected, function (n) {
          return n != imageType;
        });
      } else {
        this.filterSelected.push(imageType);
      }

      images.forEach(o => {
        this.filterSelected.length === 0 ? o.style.display = 'inline-block' : o.style.display = 'none';

        this.filterSelected.forEach(f => {
          if (o.classList.contains(f.toUpperCase()))
            o.style.display = 'list-item';
        });
      });
    },
    async fetchData() {
      this.examImages = []
      this.loading = true
      NProgress.start()
      try {
        let examResponse = await this.$examService.get({ id: this.exam_id });
        this.exam = examResponse.exam

        let response = await this.$examDataService.list({ id: this.exam.id });
        this.examImages = response.examDataList

        this.thumbDataPath = `${response.thumbDataPath}`
        this.thumbVideoPath = `${response.thumbVideoPath}`
        this.dataPath = `${response.dataPath}`

        // TODO move to service
        if (!IS_PRODUCTION) {
          this.thumbDataPath = `http://localhost:1337${response.thumbDataPath}`
          this.thumbVideoPath = null
          this.dataPath = `http://localhost:1337${response.dataPath}`
        }

        if (this.filteredExamImages.length === 0) {
          this.examImages = []
          this.alert = this.$message.alertWithTitle(this, 'request_notfound_image_title', 'request_notfound_image_text')
          // this.$message.popup(this, 'request_notfound', 'operationWarning', 'warn')
        }
      } catch (err) {
        this.$message.popup(this, 'request_error', 'operationFail', 'error')
        // this.alert = this.$message.alert(this, 'request_error', 'danger')
      } finally {
        NProgress.done(true)
        this.loading = false
      }
    },

    computeImageAiClass(item) {
      return this.$aiService.computeImageAiClass(item, this.exam)
    },
    async getScoreResult(exam) {
      try {
        this.exam.scoreResult = await this.$aiService.alterationScore(exam.metadata);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log('error', error);
      }
    },
    async doDelete(deleteId) {
      this.clearMessage()

      let params = {
        id: deleteId
      }

      this.loading = true
      NProgress.start()
      try {
        await this.$examDataService.remove(params);
        this.$message.popup(this, 'general.removedSuccess', 'operationSuccess', 'success')
        this.fetchData()
        this.selectedImages = new Array()
        // this.clearSelectedImages()
      } catch (err) {
        this.$message.popup(this, 'general.removedError', 'operationFail', 'error')
        // this.alert = this.$message.alert(this, 'general.removedError', 'danger')
      }
      NProgress.done(true)
      this.loading = false
    },
    async doDownload(item) {
      this.loading = true
      NProgress.start()
      try {
        let params = {}
        if (item.id)
          params['id'] = item.id

        if (item.uuid)
          params['uuid'] = item.uuid

        const url = this.$examDataService.getDownloadFileUrl(params)
        this.$utils.triggerFileDownload(url)
      } catch (err) {
        this.$message.popup(this, 'request_error', 'operationFail', 'error')
        // this.alert = this.$message.alert(this, 'request_error', 'danger')
      }
      NProgress.done(true)
      this.loading = false
    },
    doEdit(item) {
      this.$router.push({ name: 'exam-image-edit', params: { examDataID: item.id } })
    },
    extraCustomization() {
      let self = this

      $(".lg-download").off("click").on("click", function (event) {
        event.preventDefault();
        let examDataUUID = this.href.split('/').pop()
        let item = { uuid: examDataUUID }
        self.doDownload(item)
      })

      // this.removeEventResize()

      $('.lg-fullscreen.lg-icon').trigger('click');
    },
    getAndSetWidth() {
      let element = document.querySelectorAll('.image-info-box > .thumbnail-box');
      if (element.length) {
        let cw = element[0].offsetWidth;
        element.forEach(o => {
          o.style.height = cw + 'px';
        });
      }
    },
    // addEventResize() {
    //   window.addEventListener("resize", this.getAndSetWidth);
    // },
    // removeEventResize() {
    //   window.removeEventListener("resize", this.getAndSetWidth);
    // },
    removeLoading(event) {
      let parentNode = event.target.parentElement.classList;
      let currentlyNode = event.target.classList;

      this.$nextTick(() => {
        currentlyNode.add('loaded')
        parentNode.remove('loading-eye')
        // this.getAndSetWidth();
      });
    },
    setAlert(val) {
      this.alert.message = val.message
      this.alert.class = val.class
    },
    clearMessage() {
      this.alert.message = null
    },
    async openModalDelete(deleteId) {
      const ok = await this.$refs.offcanvasGeneric.show({
        //const ok = await this.$refs.modalGeneric.show({
        modalType: 'danger',
        title: this.$i18n.t('confirm'),
        text: this.$i18n.t('exam.confirmImageRemoval'),
        okButton: this.$i18n.t('remove'),
        okButtonClass: 'btn-danger',
        cancelButton: this.$i18n.t('cancel'),
        cancelButtonClass: 'btn-outline-secondary'
      })
      if (ok) {
        this.doDelete(deleteId)
      }
    },
    async doCheck (value) {
      let hasImg = _.find(this.selectedImages, function (o) { return o.uuid == value.uuid; });

      if (hasImg) {
        this.selectedImages = _.remove(this.selectedImages, function (n) {
          document.getElementById(value.uuid).classList.remove('checked')
          return n.uuid != value.uuid;
        });
      } else {
        document.getElementById(value.uuid).classList.add('checked')
        this.selectedImages.push(value);
      }

      let hasColor = _.find(this.selectedImages, function (o) { return o.type == 'COLOR' });
      let hasOther = _.find(this.selectedImages, function (o) { return o.type != 'COLOR' });

      this.isValidForHeatmap = !hasOther && hasColor ? true : false

      if (!this.selectedImages.length)
        this.isValidForHeatmap = false
    },

    allowEdition(image) {
      return image.endsWith('COLOR') || image.endsWith('REDFREE') || image.endsWith('TEXTURE') || image.endsWith('image')
    },

    hasTypeStatusBadge(type) {
      return this.$utils.hasTypeStatusBadge(type)
    },
    badgeTypeLabel(type) {
      return this.$utils.badgeTypeLabel(this, type)
    },
    formatFaElapsedTime(image) {
      return this.$utils.getImageFaElapsedTime(image)
    },

    isImagesValid(examDataList) {
      if (examDataList.length < 2) {
        this.$message.popup(this, 'examImages.invalidImages', 'operationWarning', 'warn')
        return false
      }

      let laterality = examDataList[0].imageLaterality;
      for (let examData of examDataList) {
        if (examData.imageLaterality != laterality) {
          this.$message.popup(this, 'examImages.notSameLaterality', 'operationWarning', 'warn')
          return false
        }
      }
      return true
    },

    isValidImagesForHeatmap(examDataList) {
      if (examDataList.length == 0) {
        this.$message.popup(this, 'examImages.noEnoughImages', 'operationWarning', 'warn')
        return false
      }
      // Max of 3 images for heatmap - Docker memory limitation.
      if (examDataList.length > 3) {
        this.$message.popup(this, 'examImages.invalidImagesHeatmap', 'operationWarning', 'warn')
        return false
      }

      return true
    },

    handleThumbError(event, item) {
      event.target.style.display = 'none';

      const container = event.target.closest('.thumbnail-box');
      container.classList.remove('loading-eye');
      container.classList.add('image-failed');
      container.addEventListener('click', (e) => {
        e.stopPropagation();
        this.doDownload(item, false);
      });
    },

    async createPanoramic() {
      const processID = this.$utils.uuidv4() // TODO use it on the general notification system
      const params = {
        processID,
        images: this.selectedImages.map(i => i.uuid),
        examData: this.selectedImages[0].img
      }
      // images: this.selectedImages.map(i.uuid),

      this.loading = true
      NProgress.start()
      try {
        await this.$examDataService.createPanoramic(params)
        this.$message.popup(this, 'examImages.requestProcessed', 'operationWarning', 'warn')
      } catch (err) {
        this.$message.popup(this, 'examImages.lambdaError', 'operationFail', 'error')
        // this.alert = this.$message.alert(this, 'examImages.lambdaError', 'danger')
      }
      NProgress.done(true)
      this.loading = false
    },

    async createStereo() {
      // images: this.selectedImages.map(i.uuid),
      const params = {
        images: this.selectedImages.map(i => i.uuid),
        examData: this.selectedImages[0].img
      }

      this.loading = true
      NProgress.start()
      try {
        this.$message.popup(this, 'examImages.generating_preview', 'operationWarning', 'warn')
        let response = await this.$examDataService.createPreview(params)
        this.openOffcanvasCropper(response.data)
      } catch (err) {
        //let res_error = err.response.data.error
        // TODO: BRUNO The same in here, in case of "instant" error on lambda, I've added this timeout
        // because the "in progress" alert is still being presented then this error alert is bypassed
        setTimeout(() => {
          this.$message.popup(this, 'examImages.createdError', 'operationFail', 'error')
        }, 2000)
        // this.alert = this.$message.alert(this, `examImages.createdError`, 'danger')
      }
      NProgress.done(true)
      this.loading = false
    },

    async createHeatmap(locale) {
      const processID = this.$utils.uuidv4() // TODO use it on the general notification system
      const params = {
        processID,
        images: this.selectedImages.map(function (item) {
          return [item.uuid, item.imageLaterality];
        }),
        examData: this.selectedImages,
        locale
      }

      this.loading = true
      NProgress.start()
      try {
        await this.$examDataService.createHeatmap(params)
        this.$message.popup(this, 'examImages.requestProcessed', 'operationWarning', 'warn')
      } catch (err) {
        this.$message.popup(this, 'examImages.lambdaError', 'operationFail', 'error')
        // this.alert = this.$message.alert(this, 'examImages.lambdaError', 'danger')
      }
      NProgress.done(true)
      this.loading = false
    },

    async openOffcanvasCropper(image) {
      this.alert.message = null;

      const ok = await this.$refs.offcanvasCropper.show({
        modalType: 'aipo',
        title: this.$i18n.t('aipo'),
        imgSrc: this.dataPath + '/' + image,
        aspectRatio: 0,
        minWidth: 100,
        minHeight: 100,
        okButton: this.$i18n.t('save'),
        okButtonClass: 'btn-primary',
        cancelButton: this.$i18n.t('cancel'),
        cancelButtonClass: 'btn-outline-secondary'
      })
      if (ok) {
        this.doSaveCroppedImage(ok.coordinates)
      }
    },
    async doSaveCroppedImage (value) {
      const processID = this.$utils.uuidv4() // TODO use it on the general notification system
      // images: this.selectedImages.map(e => e.uuid),
      let params = {
        processID,
        id: this.exam.id,
        images: this.selectedImages.map(e => e.uuid),
        examData: this.selectedImages[0].img,
        coordinates: value,
      }

      this.loading = true
      NProgress.start()
      try {
        await this.$examDataService.createStereo(params)

        // this.fetchData()
        // this.clearSelectedImages()
        this.$message.popup(this, 'examImages.requestProcessed', 'operationWarning', 'warn')
      } catch (err) {
        this.$message.popup(this, 'examImages.lambdaError', 'operationFail', 'error')
        // this.alert = this.$message.alert(this, 'examImages.lambdaError', 'danger')
      }
      NProgress.done(true)
      this.loading = false
    },
    webSocketInitialization() {
      // eslint-disable-next-line no-console
      console.log(`${TAG} webSocketInitialization()`)
      const io = this.$io
      this.isWebSocketConnected = io.socket.isConnected()
      if (this.isWebSocketConnected)
        this.webSocketForGallery()

      io.socket.on('connect', () => {
        this.isWebSocketConnected = true
        this.webSocketForGallery()
      })

      io.socket.on('disconnect', () => {
        this.isWebSocketConnected = false
      })
    },
    webSocketForGallery() {
      // eslint-disable-next-line no-console
      console.log(`${TAG} webSocketForGallery()`)
      const io = this.$io

      for (let e of ['gallery_listening', 'gallery_event']) {
        // eslint-disable-next-line no-console
        console.log('[app] unlisten to ws event:', e)
        io.socket.off(e);
      }

      const params = {
        id: this.exam.id
      }

      // TODO one listen function for clinic?
      io.socket.post('/api/v2/eyercloud/ws/listen-gallery', params, function gotResponse(body) {
        // eslint-disable-next-line no-console
        console.log(`${TAG} ws/listen-gallery:`, body);
      })

      io.socket.on('gallery_listening', function (data) {
        // eslint-disable-next-line no-console
        console.log(`${TAG} gallery_listening`, data);
      })

      io.socket.on('gallery_event', data => {
        // eslint-disable-next-line no-console
        console.log("gallery_event >>> >> >", data)
        // this.$notificationService.createNewNotification(this, data)
        NProgress.done(true)
        this.loading = false

        if (data.successfull) {
          this.$message.popup(this, `examImages.createdSuccess`, 'operationSuccess', 'success')
          this.fetchData()
          this.selectedImages = new Array()
          // this.clearSelectedImages()
        } else {
          // TODO: BRUNO In case of "instant" error on lambda, I've added this timeout
          // because the "in progress" alert is still being presented then this error alert is bypassed
          setTimeout(() => {
            this.$message.popup(this, `examImages.createdError`, `examImages.operationError`, 'error')
          }, 2000)
          // this.alert = this.$message.alert(this, `examImages.createdError`, 'danger')
        }
      })
    },
    async openOffcanvasGeneric(value) {

      if (value == 'heatmap') {
        if (!this.isValidImagesForHeatmap(this.selectedImages))
          return
      } else {
        if (!this.isImagesValid(this.selectedImages))
          return
      }

      let text = this.$i18n.t('examImages.confirmTotalImages', { image_length: this.selectedImages.length })
      const ok = await this.$refs.offcanvasGeneric.show({
        modalType: 'warning',
        title: this.$i18n.t(`examImages.title_${value}`),
        text,
        okButton: 'OK',
        okButtonClass: 'btn-primary',
        cancelButton: this.$i18n.t('cancel'),
        cancelButtonClass: 'btn-outline-secondary'
      })
      if (ok) {
        if (value == 'panoramic')
          this.createPanoramic()
        else if (value == 'stereo')
          this.createStereo()
        else
          this.createHeatmap(this.locale())
      }
    },
    getVideoSource(item) {
      let result = {
        "source": [
          {
            "src": `${this.dataPath}/${item.name}?autoplay=1`,
            "type": "video/mp4"
          }
        ],
        "attributes": {
          "preload": false,
          "playsinline": false,
          "controls": true,
          "loop": true
        }
      }

      return JSON.stringify(result)
    },
    locale() {
      return this.$utils.datePickerLocale()
    },
    // openConnectorSend() {
    //   if (!this.selectedImages.length) return
    //   const images = this.selectedImages.map(i => {
    //     const img = i.img || i
    //     return {
    //       examDataUuid: img.uuid,
    //       laterality: img.imageLaterality,
    //       eyerVersion: img.eyerVersion,
    //       type: img.type,
    //     }
    //   })
    //   this.$refs.connectorSendOffcanvas.show({
    //     clinicId: this.session.currentClinic.id,
    //     clinicUuid: this.session.currentClinic.uuid,
    //     examUuid: this.exam.uuid,
    //     images,
    //   })
    // },
    shareInformation() {
      this.showAccessInfoModal = true

      setTimeout(function () {
        let access_info_modal = document.getElementById('access_info_modal');
        new bootstrap.Modal(access_info_modal).show();
      }, 100);
    },
    onInit(detail) {
      this.lightGallery = detail.instance;
    },
    removeDownloadButton(value) {
      let item = this.examImages[value.index]
      if (item.type.endsWith('VIDEO'))
        document.querySelector('.lg-download').style.display = 'none'
      else
        document.querySelector('.lg-download').style.display = ''
    },
    async openConfirmLateralitySwitchOffcanvas(item) {
      if (!item || this.loading) return
      // "yes" (delete the original) resolves true, "no" (keep it) resolves false; either
      // way the swap goes ahead, only whether the original is deleted changes.
      const deleteOriginal = await this.$refs.offcanvasGeneric.show({
        title: this.$i18n.t('confirm'),
        text: this.$i18n.t('examImages.confirmDeleteOriginal'),
        okButton: this.$i18n.t('yes'),
        okButtonClass: 'btn-danger',
        cancelButton: this.$i18n.t('no'),
        cancelButtonClass: 'btn-outline-secondary'
      })
      this.switchLaterality(item, deleteOriginal)
    },
    async switchLaterality(item, deleteOriginal) {
      if (!item || this.loading) return
      const laterality = item.imageLaterality === 'L' ? 'R' : 'L'
      await this.$helpers.requestHandling(async () => {
        await this.$examDataService.updateLaterality({ uuid: item.uuid, laterality, deleteOriginal })
        await this.fetchData()
      }, this)
    },
    canSwitchLaterality(item) {
      const excludedTypes = new Set(['STEREO', 'STEREO_IMAGE', 'STEREO_VIDEO', 'PANO', 'VIDEO', 'PROGRESSION_VIDEO']);
      return !excludedTypes.has(item.type);
    }
  }
}
